import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const UpdatePaymentSettingsMutation = input =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation UpdatePaymentSettingsMutation($input: UpdatePaymentSettingsInput!) {
          updatePaymentSettings(input: $input) {
            clientMutationId
          }
        }
      `,
      variables: { input },
      onCompleted: resolve,
      onError: reject
    });
  });

export default UpdatePaymentSettingsMutation;
